import { OrganizationSeasonCreateRequest } from '../request-models/organization-season-create-request.model';
import { OrganizationSeasonUpdateRequest } from '../request-models/organization-season-update-request.model';
import { omitUndefined } from './wire-value-utils';

// The hub has no `_WRITABLE` list for seasons: these copy exactly the fields
// `admin-organization-seasons-controller.ts` reads (label, startDate, endDate), only when set.

/** PUT /admin/organizations/:id/seasons/:seasonId */
export function toOrganizationSeasonUpdateRequest(fields: OrganizationSeasonUpdateRequest): OrganizationSeasonUpdateRequest {
  return omitUndefined<OrganizationSeasonUpdateRequest>({
    label: fields.label,
    startDate: fields.startDate,
    endDate: fields.endDate,
  });
}

/** POST /admin/organizations/:id/seasons */
export function toOrganizationSeasonCreateRequest(fields: OrganizationSeasonCreateRequest): OrganizationSeasonCreateRequest {
  return { label: fields.label, startDate: fields.startDate, endDate: fields.endDate };
}
